import {toast} from 'sonner';
import {useNavigate} from 'react-router-dom';

import {PageId} from 'modules/decisionsNext/types/pages';

import {PageCustomSettings} from 'modules/decisionsNext/api/types';

import {
  setHasAlreadySeenWhatsNewPage,
  setNewFeaturesCount,
} from 'modules/decisionsNext/sections/WhatsNewSection/whatsNewPageStore';
import {useWhatsNewData} from 'modules/decisionsNext/sections/WhatsNewSection/useWhatsNewData';
import {decisionsGraphQLClient} from 'modules/decisionsNext/api';
import {now} from 'utils/dateUtils';
import {SEEN_FEATURES_CUSTOM_SETTING_KEY} from 'modules/decisionsNext/sections/WhatsNewSection/constants';
import {
  deleteWhatsNewToastLatestSeenDate,
  saveWhatsNewToastLatestSeenDate,
} from 'modules/decisionsNext/sections/WhatsNewSection/utils';
import {ENNABL_DECISIONS} from 'core/constants/paths';
import {
  SavePageSettingsDocument,
  SavePageSettingsMutation,
  SavePageSettingsMutationVariables,
} from 'api/pageSettings/savePageSettings.generated';

export function useSaveSeenFeatures() {
  const {allItems} = useWhatsNewData();
  const navigate = useNavigate();

  async function saveSeenFeatures() {
    const newItems = allItems.filter(item => item.isNew);

    if (newItems.length > 0) {
      const customPageSettings = [
        {
          id: SEEN_FEATURES_CUSTOM_SETTING_KEY,
          value: now(),
        },
      ];

      try {
        saveWhatsNewPageSettings(customPageSettings).then(() => {
          setNewFeaturesCount(0);
          setHasAlreadySeenWhatsNewPage(true);
          saveWhatsNewToastLatestSeenDate();
        });
      } catch {
        toast.error('There was an error with the page settings save query. Please try again later.');
      }
    }
  }

  async function resetWhatsNewPageSettings() {
    try {
      await saveWhatsNewPageSettings(undefined).then(() => {
        deleteWhatsNewToastLatestSeenDate();
        navigate(ENNABL_DECISIONS, {replace: true});
        window.location.reload();
      });
    } catch {
      toast.error('There was an error resetting the page settings. Please try again later.');
    }
  }

  return {saveSeenFeatures, resetWhatsNewPageSettings};
}

export async function saveWhatsNewPageSettings(customSettings: PageCustomSettings[] | undefined) {
  return decisionsGraphQLClient.mutate<SavePageSettingsMutation, SavePageSettingsMutationVariables>({
    mutation: SavePageSettingsDocument,
    variables: {
      settings: {
        pageId: PageId.WhatsNew,
        customSettings,
      },
    },
  });
}
